import React from 'react';
import {
  StyleSheet,
  View,
  Text,
  ScrollView,
} from './components/base_components';

import Link from './components/link';

const styles = StyleSheet.create({
  toolScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  scroller: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  scrollInner: {
    paddingLeft: '3em',
    paddingRight: '3em',
    paddingTop: '3em',
    paddingBottom: '5em',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflowY: 'scroll',
  },
  line: {
    alignSelf: 'stretch',
    height: '1px',
    backgroundColor: 'black',
  },
  headerText: {
    color: '#222',
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  title: {
    marginTop: '1em',
    marginBottom: '0.5em',
    fontSize: '1.3em',
    fontWeight: 'bold',
  },
  list: {
    marginBottom: '1em',
    flexDirection: 'column',
  },
  link: {
    marginBottom: '0.5em',
  },
});

export default class ToolScreen extends React.PureComponent {
  render() {
    return (
      <View style={styles.toolScreen}>
        <ScrollView
          style={styles.scroller}
          contentContainerStyle={styles.scrollInner}
        >
          <Text style={styles.headerText}>MONP ABT</Text>
          <Line />
          <Text style={styles.title}>Current Versions</Text>
          <Link
            style={styles.link}
            text='ABT Uploader'
            href='https://abt.monp-dev.com/ABTUploader.app.zip'
          />
          <Link
            style={styles.link}
            text='ABT Monitor'
            href='https://abt.monp-dev.com/ABTMonitor.app.zip'
          />
          <Link
            style={styles.link}
            text='ABT Installer'
            href='https://abt.monp-dev.com/ABTInstaller.app.zip'
          />
          <Line />
          <Text style={styles.title}>Next Versions</Text>
          <Link
            style={styles.link}
            text='ABT Uploader'
            href='https://abt.monp-dev.com/ABTUploader-next.app.zip'
          />
          <Link
            style={styles.link}
            text='ABT Monitor'
            href='https://abt.monp-dev.com/ABTMonitor-next.app.zip'
          />
          <Link
            style={styles.link}
            text='ABT Installer'
            href='https://abt.monp-dev.com/ABTInstaller-next.app.zip'
          />
        </ScrollView>
      </View>
    );
  }
}

function Line() {
  return <View style={styles.line} />;
}
